import { motion } from "framer-motion";
import { Briefcase } from "lucide-react";

const ROLES = [
  {
    period: "Oct 2025 — Present",
    role: "Deputy Manager — Design",
    company: "Venus Remedies Limited",
    points: [
      "Lead brand and marketing design across digital, e-commerce, retail and corporate communication.",
      "Helped establish the visual identity and creative direction for RESET, the company's consumer wellness venture.",
      "Develop scalable visual systems across campaigns, packaging and marketplace touchpoints.",
      "Collaborate with marketing, product and leadership teams to translate business requirements into effective creative communication.",
    ],
    current: true,
  },
  {
    period: "Aug 2020 — Oct 2025",
    role: "Sr. Visual Designer",
    company: "PrepLadder by Unacademy, Chandigarh",
    points: [
      "Created performance-marketing campaigns for Meta and Google, with selected campaigns delivering up to 6–8x ROAS.",
      "Developed a scalable YouTube thumbnail design system that contributed to a consistent 5-7% average CTR.",
      "Delivered 500+ creative assets in the last 6 months across social media, marketing campaigns and product communication.",
      "Contributed to brand, product and marketing design for a leading medical-education platform.",
    ],
    current: false,
  },
  {
    period: "2016 — 2020",
    role: "Graphic Designer → Senior Designer",
    company: "Agencies & Studios, Chandigarh",
    points: [
      "Built foundational experience across branding, print, packaging and digital campaigns for clients across industries.",
      "Progressed from execution-focused design to taking ownership of client-facing creative direction.",
    ],
    current: false,
  },
];

export default function Timeline() {
  return (
    <section id="experience" data-testid="experience-section" className="py-20 lg:py-24 border-t border-[#222634]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#FF4D23] mb-3">04 · Experience</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase mb-14" data-testid="experience-heading">
          From Craft to <span className="text-[#FF4D23]">Creative Leadership</span>
        </h2>
        <div className="relative pl-8 sm:pl-12">
          <div className="absolute left-2 sm:left-4 top-1 bottom-1 w-px bg-[#222634]" />
          <div className="space-y-12">
            {ROLES.map((r, i) => (
              <motion.div
                key={r.role}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
                data-testid={`timeline-item-${i}`}
              >
                <span
                  className={`absolute -left-8 sm:-left-12 top-1.5 w-4 h-4 rounded-full border-4 border-[#0A0B0E] ${
                    r.current ? "bg-[#FF4D23]" : "bg-[#3B4254]"
                  }`}
                  style={{ marginLeft: "2px" }}
                />
                <p className="font-mono2 text-xs tracking-widest uppercase text-[#8A92A3] mb-2">
                  {r.period} {r.current && <span className="text-[#FF4D23] ml-2">· Current</span>}
                </p>
                <h3 className="font-display font-bold text-xl sm:text-2xl flex items-center gap-3">
                  <Briefcase size={20} className="text-[#FF4D23] shrink-0" /> {r.role}
                </h3>
                <p className="text-sm text-[#B6BDCB] font-medium mt-1 mb-4">{r.company}</p>
                <ul className="space-y-2">
                  {r.points.map((p) => (
                    <li key={p} className="text-sm leading-relaxed text-[#B6BDCB] flex gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#FF4D23] mt-2 shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
